import { Beneficiary } from "./beneficiary";
import { User } from "./user";

export enum MeetingStatus {
  COMING = "COMING",
  DONE = "DONE",
  CANCELED = "CANCELED",
  ON_ERROR = "ON_ERROR",
  IN_PROGRESS = "IN_PROGRESS",
}

export type Meeting = {
  id: string;
  meeting_date: string;
  start_at: string;
  status: MeetingStatus;
  beneficiary: Beneficiary;
  kine: User;
  kine_token: string;
  session_id: string;
  observation_evolution: string;
  observation_exercises: string;
  observation_objectifs: string;
  connectionTrouble: boolean;
  is_repport_done: boolean;
};

export type GroupedMeetings = Record<string, Meeting[]>;
